import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@shared/utils/route.utils.ts';
import AllIntegrations from './pages/all-integrations/all-integrations.tsx';
import HotelSmartersProducts from './pages/hotel-smarters-products/hotel-smarters-products.tsx';

const Intagrations = lazy(() => import('./integrations.tsx'));

export const integrationsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <Intagrations />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.Integrations.AllIntegrations.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.Integrations.AllIntegrations.path,
        element: (
          <Suspense>
            <AllIntegrations />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Integrations.HotelProducts.path,
        element: (
          <Suspense>
            <HotelSmartersProducts />
          </Suspense>
        )
      }
    ]
  }
];
